var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "ticketDialog",
      attrs: {
        title: "异常改签-确认行程信息",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
        "append-to-body": true,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-descriptions",
        { attrs: { title: "原班次信息", column: 3, size: "small" } },
        [
          _c("el-descriptions-item", { attrs: { label: "班次时间" } }, [
            _vm._v(_vm._s(_vm.nInfo.flightPlanTime)),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "乘客端显示时间(门到门模式)" } },
            [_vm._v("\n      " + _vm._s(_vm.oldDoorTime) + "\n    ")]
          ),
          _c("el-descriptions-item", { attrs: { label: "座位号" } }, [
            _vm._v(_vm._s(_vm.nInfo.seateStr)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "下单人手机号" } }, [
            _vm._v(_vm._s(_vm.nInfo.mobilePhone)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "票价全额" } }, [
            _vm._v(_vm._s(_vm.nInfo.payAmountYuan)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "接服务费" } }, [
            _vm._v(_vm._s(_vm.nInfo.meetOrderAmountYuan)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "送服务费" } }, [
            _vm._v(_vm._s(_vm.nInfo.sendOrderAmountYuan)),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "padding-top": "20px" } },
        [
          _c("el-descriptions", {
            attrs: { title: "新班次信息", size: "small" },
          }),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 10 } }, [
                _vm._v(
                  "班次时间: " +
                    _vm._s(
                      _vm.info.departureDate + " " + _vm.info.departureTime
                    )
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 10 } }, [
                _vm._v(
                  "新班次乘客端显示时间(门到门模式): " + _vm._s(_vm.newDoorTime)
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 10 } }, [
                _vm._v("\n        座位号:\n        "),
                _c(
                  "div",
                  { staticClass: "seatContainer" },
                  _vm._l(_vm.seatArray, function (iterm, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      _vm._l(iterm, function (seat, index2) {
                        return _c(
                          "el-col",
                          {
                            key: index2,
                            staticClass: "seatBox",
                            nativeOn: {
                              click: function ($event) {
                                return _vm.selectSeatEvent(seat)
                              },
                            },
                          },
                          [
                            seat.state === -2
                              ? _c("span", { staticClass: "seatSpan" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "seatText",
                                      staticStyle: {
                                        color: "#ffffff",
                                        "-webkit-user-select": "none",
                                        "user-select": "none",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(seat.seatNo) +
                                          "号座\n                  "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                  ￥" +
                                          _vm._s(seat.sellingPrice) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  seat.state === -2
                                    ? _c("span", {
                                        staticClass: "unableSeat seatIcon",
                                      })
                                    : _vm._e(),
                                ])
                              : seat.state === -1
                              ? _c("span", { staticClass: "seatSpan" })
                              : seat.state === 0
                              ? _c("span", { staticClass: "seatSpan" }, [
                                  _c("span", { staticClass: "seatText" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(seat.seatNo) +
                                        "号座\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ￥" +
                                        _vm._s(seat.sellingPrice) +
                                        "\n                "
                                    ),
                                  ]),
                                  _c("span", {
                                    staticClass: "ableSeat seatIcon",
                                  }),
                                ])
                              : seat.state === 1
                              ? _c("span", { staticClass: "seatSpan" }, [
                                  _c("span", { staticClass: "seatText" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(seat.seatNo) +
                                        "号座\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ￥" +
                                        _vm._s(seat.sellingPrice) +
                                        "\n                "
                                    ),
                                  ]),
                                  _c("span", {
                                    staticClass: "soldSeat seatIcon",
                                  }),
                                ])
                              : seat.state === 2
                              ? _c("span", { staticClass: "seatSpan" }, [
                                  _c("span", { staticClass: "seatText" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(seat.seatNo) +
                                        "号座\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ￥" +
                                        _vm._s(seat.sellingPrice) +
                                        "\n                "
                                    ),
                                  ]),
                                  _c("span", {
                                    staticClass: "lockSeat seatIcon",
                                  }),
                                ])
                              : seat.state === 3
                              ? _c("span", { staticClass: "seatSpan" }, [
                                  _c("span", { staticClass: "seatText" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(seat.seatNo) +
                                        "号座\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  ￥" +
                                        _vm._s(seat.sellingPrice) +
                                        "\n                "
                                    ),
                                  ]),
                                  _c("span", { staticClass: "seat seatIcon" }),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "tipsBox" }, [
            _c("img", {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { src: require("./static/tips.png") },
            }),
            _c("span", [_vm._v("先选择座位，选择的座位数需和乘车人数相同！")]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.seateSelectArr, size: "mini", border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "票价全额",
                  align: "center",
                  prop: "payAmountYuan",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "接服务",
                  align: "center",
                  prop: "meetOrderAmountYuan",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "送服务",
                  align: "center",
                  prop: "sendOrderAmountYuan",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "增值服务",
                  align: "center",
                  prop: "insureAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认改签")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确定改签吗？",
            visible: _vm.submitDialogVisible,
            width: "30%",
            "before-close": _vm.handleSubmitClose,
            center: "",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.submitDialogVisible = $event
            },
          },
        },
        [
          _vm.pickerOrderTip || _vm.carryOrderTip
            ? [
                _c("p", [
                  _vm._v(
                    "该订单关联的摆渡订单已有司机接单，改签请电话联系摆渡司机确认！"
                  ),
                ]),
                _vm.pickerOrderTip
                  ? _c("p", [_vm._v(_vm._s(_vm.pickerOrderTip))])
                  : _vm._e(),
                _vm.carryOrderTip
                  ? _c("p", [_vm._v(_vm._s(_vm.carryOrderTip))])
                  : _vm._e(),
                _vm.cityOrderTip
                  ? _c("p", [_vm._v(_vm._s(_vm.cityOrderTip))])
                  : _vm._e(),
              ]
            : _vm._e(),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请填写改签原因！",
              maxlength: "50",
              "show-word-limit": "",
            },
            model: {
              value: _vm.sendMsgContent,
              callback: function ($$v) {
                _vm.sendMsgContent = $$v
              },
              expression: "sendMsgContent",
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleSubmitClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }